import { useTranslation } from "next-i18next";
import Image from "next/image";
import Link from "next/link";
import { useState } from "react";
import { useGlobalState } from "../context/GlobalStateContext";
import { apiClient } from "helpers/api-client";
import { validateEmail } from "helpers/form/validators";
import { h2FontSize } from "utils/common";
import { routes } from "helpers/routes";

const Sponsoring = () => {
  const { addToaster, removeToaster, direction } = useGlobalState();
  const { t: translate } = useTranslation("contact");
  const [email, setEmail] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();

    const emailError = validateEmail(email);
    const isEmailValid = emailError === "";

    if (!email || !isEmailValid) {
      addToaster({
        message: translate("invalidEmail"),
        type: "error",
        callback: (index) => removeToaster(index),
      });
      return;
    }

    apiClient
      .post({
        uri: "/email",
        body: {
          email: email,
          name: email,
          message: "Sponsoring newsletter email",
        },
      })
      .then(() => {
        addToaster({
          message: translate("sendMailSuccess"),
          type: "success",
          callback: (index) => removeToaster(index),
        });
        setEmail("");
      })
      .catch((error) => {
        console.error("API Error:", error);
        addToaster({
          message: translate("sendMailFail"),
          type: "error",
          callback: (index) => removeToaster(index),
        });
      });
  };
  return (
    <div className="flex flex-col md:flex-row justify-evenly items-start min-w-[350px] pb-16 relative">
      <img
        src="/images/yellow-square.svg"
        alt="yellow-square"
        width="100px"
        height="4"
        className="absolute top-6 left-5 md:left-[9%] "
      />

      {/* Wrapper for Left and Right sections */}
      <div className="flex flex-col md:flex-row justify-evenly items-start w-full gap-y-10 md:gap-x-5 lg:gap-x-10 py-20 xs:px-10 md:px-3">
        {/* Left Section */}
        <div className="flex flex-col justify-between gap-y-4 md:w-[50%] lg:w-[35%] xs:w-[100%] h-full items-center md:items-start min-h-[220px] ">
          <h2
            className={`m-0 p-0 ${h2FontSize} font-bold text-[#233377] leading-tight rtl:text-right`}
          >
            {translate("sponsor_content")}
          </h2>

          {/* Form aligned at bottom */}
          <form
            onSubmit={handleSubmit}
            className="relative xs:w-full sm:w-[90%] lg:w-[70%] self-start"
          >
            <input
              value={email}
              type="search"
              id="send-email"
              className="block p-4 pl-10 w-full text-lg text-gray-900 bg-white rounded-lg border border-gray-300 outline-none"
              placeholder={translate("email")}
              onChange={(e) => setEmail(e.target.value)}
            />
            <div
              className={`flex absolute inset-y-0 items-center pr-3 cursor-pointer ${
                direction === "ltr" ? "right-0" : "left-0 rotate-0 ml-8"
              }`}
            >
              <button
                className="rounded-lg shadow-lg bg-[#233377] p-2 min-w-max -ml-5"
                type="submit"
              >
                <div className="rtl:-scale-x-100">
                  <Image
                    src="/images/subscription.png"
                    alt="subscription icon"
                    width={32.28}
                    height={28}
                    style={{ maxWidth: "100%", height: "auto" }}
                  />
                </div>
              </button>
            </div>
          </form>
        </div>

        {/* Right Section */}
        <div className="flex flex-col gap-y-4  w-[80%]  md:w-[50%] lg:w-[35%] xs:w-[100%] xs:items-center md:items-start   min-h-[220px] ">
          <p className="xs:text-2xl md:text-3xl font-bold text-[#233377] ">
            {translate("title_sponsoring")}
          </p>
          <p className="text-md text-justify">{translate("sponsoring_paragraph")}</p>
          <Link href={routes.REQUEST_DEMO} passHref legacyBehavior>
            <button className="text-white font-medium bg-[#233377] w-2/3 md:w-[65%]  h-[60.71px] rounded-lg xs:text-sm md:text-[18px] lg:text-xl mt-auto md:px-2">
              {translate("start_now")}
            </button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Sponsoring;
